import React, {FunctionComponent} from 'react';
import './InvoiceAddOnOptionTile.scss';
import Checkbox from "../ui-components/Checkbox/Checkbox";
import {VerticalDivider} from "../ui-components/VerticalDivider/VerticalDivider";
import {UI_PARAMS} from "@flicent/fieldpulse-react-component-library-frontend";
import {Button} from "../ui-components/Button/Button";
import {InvoiceOptionTileProps} from "../InvoiceOption/InvoiceOptionTile";
import {InvoiceOption} from "../../models/item.model";

export interface InvoiceAddOnOptionTileProps {
    option: InvoiceOption;
    isSelectedOption: boolean;
    onSelectOption: (selectedOption: InvoiceOption) => void;
}

export const InvoiceAddOnOptionTile: FunctionComponent<InvoiceAddOnOptionTileProps> = ({
                                                                                           option,
                                                                                           isSelectedOption,
                                                                                           onSelectOption
                                                                                       }) => {
    return (
        <article className="invoice-add-on-option-tile selected-option-information">
            {
                option.photo_src &&
                <section className="photo-container">
                    <img src={option.photo_src} alt={`Selected Option Picture`}/>
                </section>

            }

            {
                option.description?.length > 0 && <VerticalDivider color={UI_PARAMS.DIVIDER_COLOR}
                                                                   width={3}
                                                                   borderRadius={5}
                                                                   margin={'0 15px 0 0'}/>
            }

            <section className="main-info-container">
                <h3>
                    <Checkbox checked={isSelectedOption} onChange={() => {
                        onSelectOption(option);
                    }} style={{margin: '0 5px 0 0'}}/>
                    {option.title || option.option_name}
                </h3>

                {
                    option?.description.length > 0 &&
                    <p className="selected-option-description">{option.description}</p>
                }
            </section>

            <section className="select-info-container">
                <h4 className="option-price">
                    {option.total}
                </h4>

                <div>
                    {!isSelectedOption &&
                        <Button className='selected-option-action-button fp-button' onClick={() => onSelectOption(option)}>
                            <i className="fa-regular fa-plus"></i>
                            Add Option
                        </Button>}
                    {isSelectedOption &&
                        <Button className='selected-option-action-button fp-outline-button'
                                onClick={() => onSelectOption(option)}>
                            <i className="fa-regular fa-minus"></i>
                            Remove Option
                        </Button>}
                </div>
            </section>
        </article>
    );
};
